import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faSpinner } from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import {
  CancelButton,
  FormFooter,
  PreviewButton,
  PrimaryActions,
  SaveExitButton,
  SaveLessonsButton,
} from './styled'

interface CourseFormFooterProps {
  loading: boolean
  disabledSave: boolean
  showGoToLessons: boolean
  showPreview: boolean
  disableGoToLessons?: boolean
  onCancel: () => void
  onSaveAndExit: () => void
  onGoToLessons: () => void
  onPreview?: () => void
}

export const CourseFormFooter: React.FC<CourseFormFooterProps> = ({
  loading,
  disabledSave,
  showGoToLessons,
  showPreview,
  disableGoToLessons = false,
  onCancel,
  onSaveAndExit,
  onGoToLessons,
  onPreview,
}) => {
  const t = useTranslationRankmi({
    prefix: 'administration.courses.new.form.buttons',
  })
  const tLessons = useTranslationRankmi({
    prefix: 'administration.lessons.buttons',
  })

  return (
    <FormFooter>
      <CancelButton type="button" onClick={onCancel}>
        {t('cancel')}
      </CancelButton>
      <PrimaryActions>
        {showPreview && onPreview ? (
          <PreviewButton type="button" disabled={loading} onClick={onPreview}>
            {tLessons('preview')}
          </PreviewButton>
        ) : null}
        <SaveExitButton
          type="button"
          disabled={disabledSave}
          onClick={onSaveAndExit}
        >
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin aria-hidden />
          ) : null}
          {t('saveAndExit')}
        </SaveExitButton>
        {showGoToLessons ? (
          <SaveLessonsButton
            type="button"
            disabled={disabledSave || disableGoToLessons}
            onClick={onGoToLessons}
          >
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin aria-hidden />
            ) : null}
            {t('goTolessons')}
            <FontAwesomeIcon icon={faArrowRight} aria-hidden />
          </SaveLessonsButton>
        ) : null}
      </PrimaryActions>
    </FormFooter>
  )
}

export default CourseFormFooter
